var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  formatDate: () => formatDate,
  isUndefined: () => isUndefined,
  regexTest: () => regexTest
});
const regexTest = (value, regex) => {
  const result = regex.test(value);
  regex.lastIndex = 0;
  return result;
};
const isUndefined = (value) => typeof value === "undefined";
const formatDate = (date) => {
  if (typeof date !== "string" || date.length !== 8) {
    return "";
  }
  return `${date.slice(4, 8)}-${date.slice(2, 4)}-${date.slice(0, 2)}`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  formatDate,
  isUndefined,
  regexTest
});
